import React from "react";
import {
  Box,
  Container,
  SimpleGrid,
  Flex,
  Text,
  VStack,
  Divider,
} from "@chakra-ui/react";
import { CalendarDays, Users, Building2, BookOpenCheck } from "lucide-react";
import { useText } from "../../../i18n/lang";

const TEXT = {
  en: {
    stats: [
      "years on the market",
      "staff",
      "years - average Travel Time consultant expertise",
      "corporate customers",
    ],
  },
  ro: {
    stats: [
      "ani pe piața din România",
      "angajați",
      "ani - media de expertiză a consultanților Travel Time",
      "clienți corporate",
    ],
  },
};

const StatBox = ({ icon: Icon, number, text }) => (
  <Box
    bg="white"
    p={10}
    borderRadius="lg"
    boxShadow="lg"
    transition="transform 0.2s"
    _hover={{ transform: "translateY(-5px)" }}
  >
    <VStack spacing={5}>
      <Flex
        w="60px"
        h="60px"
        bg="blue.50"
        borderRadius="full"
        align="center"
        justify="center"
      >
        <Icon size={30} color="#3182ce" />
      </Flex>
      <Text
        fontSize={["5xl", "4xl"]}
        fontWeight="bold"
        color="#000f40"
        fontFamily="'Montserrat', sans-serif"
        sx={{
          WebkitTextStrokeWidth: "1px",
          WebkitTextFillColor: "#fff",
          WebkitTextStrokeColor: "#3182ce",
          lineHeight: "33px",
        }}
      >
        {number}
      </Text>
      <Text
        fontSize={["md", "md"]}
        textAlign="center"
        color="gray.600"
        fontWeight="medium"
        fontFamily="'Montserrat', sans-serif"
      >
        {text}
      </Text>
    </VStack>
  </Box>
);

const StatsSection = () => {
  const t = useText(TEXT);
  const stats = [
    {
      icon: CalendarDays,
      number: "20",
      text: t.stats[0],
    },
    {
      icon: Users,
      number: "30+",
      text: t.stats[1],
    },
    {
      icon: BookOpenCheck,
      number: "12+",
      text: t.stats[2],
    },
    {
      icon: Building2,
      number: "100+",
      text: t.stats[3],
    },
  ];

  return (
    <>
      <Container maxW="container.lg" py={12}>
        <Box width={["100%", "100%"]} mx="auto">
          <SimpleGrid columns={[1, 2, 2, 4]} spacing={8}>
            {stats.map((stat, index) => (
              <StatBox
                key={index}
                icon={stat.icon}
                number={stat.number}
                text={stat.text}
              />
            ))}
          </SimpleGrid>
        </Box>
      </Container>
    </>
  );
};

export default StatsSection;
